import { useFormik } from "formik";
import Chip from "global/Chip/Chip";
import CustomPersonalizeForm from "global/CustomSwitchInput/CustomPersonalizeForm";
import MultiDatePicker from "global/DatePicker/multi-date-picker";
import {
  useFetchHub,
  useFetchSampleOptions,
} from "global/hooks/useFetchOptions";
import InputTreeSelect from "global/InputSelect/inputTreeSelect";
import { paginationType } from "global/Interfaces/Interfaces";
import SimpleButton from "global/SimpleButton/SimpleButton";
import { FC, useEffect, useState } from "react";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import {
  clearSharePercent,
  filterSharePercent,
  setFilterSharePercent,
} from "redux/share-percent";
import { SharePercentFilterElements } from "./SharePercentFilterElements";
import { filterType } from "./utils";

interface PropsData {
  isActive: boolean;
}

const SearchForm: FC<PropsData> = ({ isActive }) => {
  const {
    dataOptions: { options: typeOption },
  } = useFetchSampleOptions("/core-api/sharePercentage/sharePercentageTypes");
  const {
    dataOptions: { options: hubData },
  } = useFetchSampleOptions("/core-api/hub/allAbleToRegisterOrder");

  const userInfo = useSelector((state: any) => state.userInfo);
  const [chipData, setChipData] = useState("");
  const [selectedNodes, setSelectedNodes] = useState([
    {
      id: userInfo.currenthub?.id,
      label: userInfo.currenthub?.label,
    },
  ]);

  const { pageNumbers } = useSelector(
    (state: paginationType) => state.paginate
  );
  const { options: hubOptions } = useFetchHub();

  const [filterData, setFilterData] = useState({});
  const dispatch = useDispatch();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      validFrom: undefined,
      validTo: undefined,
      // isActive: true,
      hub: { id: userInfo.currenthub?.id },
      type: undefined,
    },
    onSubmit: async (values: any) => {
      const finalData = {
        ...values,
        to: values.validTo ?? undefined,
        from: values.validFrom ?? undefined,
      };

      setFilterData(finalData);
      setChipData({ ...finalData, hub: undefined });
    },
  });

  const { values, handleSubmit, setFieldValue }: any = formik;

  useEffect(() => {
    const finalData = {
      ...values,
      isActive,
    };
    dispatch(setFilterSharePercent({ ...finalData }));
    dispatch(
      filterSharePercent({
        ...finalData,
        pageSize: 10,
        pageNumber: pageNumbers,
      }) as any
    );
    return () => {
      dispatch(clearSharePercent());
    };
  }, [filterData, pageNumbers, values.hub, isActive]);

  return (
    <>
      <div className=" flex items-start justify-end Max-sm:contents  mt-6 ">
        <div className="flex gap-2 w-[20rem]  items-center autocompleteWrapper focus:shadow-none">
          <MultiDatePicker
            title=" از تاریخ"
            name={`from`}
            values={values.from}
            handleChange={setFieldValue}
            WrapperClassName=" !shadow-none "
          />
          <div className=" w-12">
            <HiOutlineArrowLeft />
          </div>
          <MultiDatePicker
            title="تا تاریخ"
            name={`to`}
            values={values.to}
            handleChange={setFieldValue}
            WrapperClassName=" !shadow-none"
            // minDate={values.fromDate ? values.fromDate : getTodayPersianDate()}
          />
        </div>
      </div>
      <form onSubmit={handleSubmit} className="searchForm ">
        <InputTreeSelect
          customTree={[hubData]}
          selectedNodes={selectedNodes}
          setSelectedNodes={setSelectedNodes}
          type="select"
          singleSelect
          wrapperClassName="filterInput"
          initialValue={selectedNodes[0]?.label || userInfo.currenthub?.label}
          onSelect={(value) => {
            setSelectedNodes(value);
            formik.setFieldValue("hub", { id: value[0]?.id });
          }}
        />
        {SharePercentFilterElements.filter((item) => item.isMain).map(
          (item: any, index: number) => {
            return (
              <CustomPersonalizeForm
                key={index}
                element={item}
                formik={formik}
                selectOptions={{
                  hubOptions,
                  typeOption: filterType(typeOption),
                }}
              />
            );
          }
        )}

        <SimpleButton searchBtn />
      </form>

      {filterData && (
        <Chip
          filterData={chipData}
          formData={formik}
          action={() => setSelectedNodes([])}
        />
      )}
    </>
  );
};

export default SearchForm;
